import {
  FieldError,
  FieldHint,
  Field as SharedField,
  FieldLabel as SharedFieldLabel
} from '@novelaide/ui/components/Field'
import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface FieldProps extends HTMLAttributes<HTMLDivElement> {
  label: ReactNode
  labelFor?: string
  hint?: ReactNode
  error?: ReactNode
}

export function Field({ label, labelFor, hint, error, children, className, ...props }: FieldProps) {
  return (
    <SharedField className={cn(className)} {...props}>
      <SharedFieldLabel htmlFor={labelFor}>{label}</SharedFieldLabel>
      {children}
      {hint ? <FieldHint>{hint}</FieldHint> : null}
      {error ? <FieldError role="alert">{error}</FieldError> : null}
    </SharedField>
  )
}
